var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import './brand-loading.css';
export var BrandLoading = function (_a) {
    var width = _a.width;
    return (_jsxs("div", __assign({ className: '_8582b04db9-brand-content' }, { children: [_jsx("div", { className: '_8582b04db9-brand-dot' }, void 0), _jsx("div", { className: '_8582b04db9-brand-dot' }, void 0), _jsx("div", { className: '_8582b04db9-brand-dot' }, void 0)] }), void 0));
};
